import { AxiosResponse } from "axios";
import { Servicio } from "../interfaces/servicio.interface";
import { BACKEND_ENDPOINT, SERVICIO } from "../utils/constants";

export const getServicioFromBackend = (apiRequest: any) => {
    return new Promise<Servicio[]>((resolve, reject) => {
        const url = BACKEND_ENDPOINT() + SERVICIO;
        const method = 'GET';
        const options = {
            url,
            method
        }
        apiRequest(options)
            .then((response: AxiosResponse) => resolve(response.data))
            .catch((error : any) => reject(error));
    });
}
